module.exports = __webpack_public_path__ + "img/banner-3.ed26f7a3.jpg";